if (customElements.get('quick-add-terms') === undefined) {
  class QuickAddTerms extends HTMLElement {
    constructor() {
      super();

      this.termsDialog = this.querySelector('details');
      this.quickAdd = this.querySelector('quick-add');
      this.addToCartButton = this.quickAdd.querySelector('button');

      if (this.accepted || this.addToCartButton.disabled) return;

      this.showTermsHandler = this.showTerms.bind(this);
      this.hideTermsHandler = this.hideTerms.bind(this);

      this.addEventListener('click', this.showTermsHandler, false);
      this.addEventListener('mouseover', this.showTermsHandler, false);
      this.addEventListener('mouseout', this.hideTermsHandler, false);

      this.addToCartButton.setAttribute('aria-describedby', this.termsDialog.id);
    }

    showTerms() {
      if (this.accepted) return;
      this.addToCartButton.setAttribute('disabled', true);
      this.termsDialog.setAttribute('open', '');
      this.querySelector('[data-accept-terms]').addEventListener('click', this.acceptTerms.bind(this), false);
    }

    hideTerms() {
      this.termsDialog.removeAttribute('open');
    }

    acceptTerms() {
      this.accepted = true;
      this.termsDialog.removeAttribute('open');
      this.termsDialog.style.display = 'none';
      this.addToCartButton.removeAttribute('disabled');
      this.addToCartButton.removeAttribute('aria-describedby')
      this.addToCartButton.focus();

      this.removeEventListener('click', this.showTermsHandler, false);
      this.removeEventListener('mouseover', this.showTermsHandler, false);
      this.removeEventListener('mouseout', this.hideTermsHandler, false);
    }
  }

  customElements.define('quick-add-terms', QuickAddTerms);
}
